export const homeServices = [
  {
    id: 'walking',
    title: 'Walking Services',
    description: 'Discover a vetted dog lover in your city. Our platform seamlessly matches you with local professionals for safe, joyful, and tailored walks. We find the perfect companion so you don\'t have to',
    price: 'From $15 / walk',
    image: 'https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/95547f8e3b34d41f1d1b8c39050aaa70.jpeg',
  },
  {
    id: 'sitting',
    title: 'Home Sitting',
    description: 'Leave your pet in the familiar comfort of home. Our platform matches you with vetted, local sitters who provide dedicated overnight care and companionship. Travel with peace of mind, knowing your companion is safe and loved.',
    price: 'From $65 / day',
    image: 'https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/ae2bd4e6d79b9e8516e1330ee5dcf3ee.jpeg',
  },
  {
    id: 'training',
    title: 'Behavior Training',
    description: 'Unlock your pet\'s full potential with our curated network of elite behaviorists. We match you with specialized trainers focused on positive reinforcement and modern techniques. Foster a deeper bond through personalized, expert-led guidance in your city.',
    price: 'From $50 / session',
    image: 'https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/f40b39634fa8457f304152c816fc1f24.webp',
  },
  {
    id: 'grooming',
    title: 'Grooming Studio',
    description: 'Elevate your pet\'s style with our hand-picked selection of top-tier grooming masters. We connect you with vetted studios specializing in stress-free artistry and wellness. Treat your companion to a luxury spa experience tailored for their unique coat.',
    price: 'From $35 / session',
    image: 'https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/26faed1116b569e73e50af2db1301df3.jpeg',
  },
];

export const homePets = [
  { id: 1, name: 'Luna', breed: 'Golden Retriever', age: '2 years', status: 'available', image: 'https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/4a66feafbd99bd097f582317a23752b6.jpeg' },
  { id: 2, name: 'Oliver', breed: 'French Bulldog', age: '1 year', status: 'available', image: 'https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/f96dd0b1daf25dc112aeecae8a4a0ade.webp' },
  { id: 3, name: 'Milo', breed: 'Australian Shepherd', age: '3 years', status: 'pending', image: 'https://static.readdy.ai/image/1f65bef57b9643672cbad222c3f4355a/d95e9bd1ba44b1820e3e4bca3003545f.jpeg' },
  { id: 4, name: 'Bella', breed: 'Labrador Mix', age: '4 years', status: 'available', image: 'https://readdy.ai/api/search-image?query=A%20friendly%20labrador%20mix%20dog%20portrait%20sitting%20outdoors%20in%20natural%20light%20warm%20earthy%20tones%20cream%20background%20editorial%20pet%20photography%20style%20high%20quality%20professional%20photography&width=400&height=500&seq=8&orientation=portrait' },
];

export const homeTestimonials = [
  {
    id: 1,
    headline: 'Exceptional care for Max',
    body: 'Paw & Co. transformed our daily routine. The walking service is punctual, professional, and Max comes home genuinely happy. We have tried three other services before finding them.',
    author: 'Sarah Mitchell',
    role: 'Dog parent, Brooklyn',
    rating: 5,
  },
  {
    id: 2,
    headline: 'Training that actually works',
    body: 'After six weeks with their behavior specialist, our rescue dog went from anxious to confident. The positive reinforcement approach made all the difference.',
    author: 'James Chen',
    role: 'First-time adopter',
    rating: 5,
  },
  {
    id: 3,
    headline: 'The grooming is art',
    body: 'I have never seen my poodle look this good. The attention to detail is remarkable, and the boutique products they use leave her coat silky for weeks.',
    author: 'Elena Rodriguez',
    role: 'Poodle owner, Manhattan',
    rating: 5,
  },
];

export const bookingServices = [
  'Dog Walking',
  'Pet Sitting',
  'Behavior Training',
  'Grooming Studio',
  'Pet Matchmaking',
];

export const timeSlots = [
  '08:00 AM',
  '09:30 AM',
  '11:00 AM',
  '02:00 PM',
  '04:30 PM',
  '06:00 PM',
];